export default {
  name: 'SlideToggle',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    inputId: {
      type: String,
      required: true
    },
    onLabel: {
      type: String,
      required: true
    },
    offLabel: {
      type: String,
      required: true
    },
    reverse: {
      // if true, "on" value will be on the left
      type: Boolean,
      default: true
    },
    outline: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Boolean,
      default: true
    }
  }
};